import { render, staticRenderFns } from "./DevicesAdmin.vue?vue&type=template&id=133d953a&"
import script from "./DevicesAdmin.vue?vue&type=script&lang=js&"
export * from "./DevicesAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports